import { useState, useCallback, useRef } from 'react';

function getNextIndex(subjects, prefix) {
  let max = 0;
  const re = new RegExp(`^${prefix}(\\d+)$`);
  for (const s of subjects) {
    const m = s.name.match(re);
    if (m) {
      max = Math.max(max, parseInt(m[1], 10));
    }
  }
  return max + 1;
}

function detectMediaType(url, fileOrUrl) {
  let ext = '';
  if (fileOrUrl && typeof fileOrUrl !== 'string') {
    ext = (fileOrUrl.name || '').split('.').pop().toLowerCase();
  } else {
    const src = fileOrUrl || url;
    const m = (typeof src === 'string' ? src : '').match(/\.(\w+)(\?|$)/);
    ext = m ? m[1].toLowerCase() : '';
  }

  if (['mp4', 'webm', 'mov', 'avi', 'mkv'].includes(ext)) return 'video';
  if (['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'].includes(ext)) return 'audio';
  return 'image';
}

function getPrefix(mediaType) {
  if (mediaType === 'video') return '视频';
  if (mediaType === 'audio') return '音频';
  return '图片';
}

export default function useSubjects() {
  const [subjects, setSubjects] = useState([]);
  const subjectsRef = useRef([]);
  const nextSubjectIdRef = useRef(0);

  const createSubjectId = useCallback(() => {
    nextSubjectIdRef.current += 1;
    return `subj-${Date.now()}-${nextSubjectIdRef.current}`;
  }, []);

  const addSubject = useCallback((subject) => {
    const next = [subject, ...subjectsRef.current];
    subjectsRef.current = next;
    setSubjects(next);
  }, []);

  const removeSubject = useCallback((id) => {
    const next = subjectsRef.current.filter((s) => s.id !== id);
    subjectsRef.current = next;
    setSubjects(next);
  }, []);

  const replaceSubjects = useCallback((nextSubjects) => {
    const resolvedSubjects = Array.isArray(nextSubjects) ? nextSubjects : [];
    subjectsRef.current = resolvedSubjects;
    setSubjects(resolvedSubjects);
  }, []);

  const addUploadSubject = useCallback((url, fileOrUrl) => {
    const mediaType = detectMediaType(url, fileOrUrl);
    const prefix = getPrefix(mediaType);
    const idx = getNextIndex(subjectsRef.current, prefix);
    const name = `${prefix}${idx}`;
    const subject = {
      id: createSubjectId(),
      name,
      mediaType,
      imageUrl: mediaType === 'image' ? url : '',
      sourceUrl: url,
    };

    const next = [subject, ...subjectsRef.current];
    subjectsRef.current = next;
    setSubjects(next);

    return subject;
  }, [createSubjectId]);

  return { subjects, addSubject, removeSubject, replaceSubjects, addUploadSubject };
}
